<template>
  <el-dialog title="物流详情" :visible.sync="formVisible" width="800px" v-if="formVisible">
    <el-timeline :reverse="reverse">
      <el-timeline-item v-for="(activity, index) in list" :key="index" :timestamp="activity.time">
        {{activity.status}}
      </el-timeline-item>
    </el-timeline>
  </el-dialog>
</template>
<script>
import goodsOrderApi from '@/api/order/goodsOrder'
export default {
  data() {
    return {
      formVisible: false,
      list: [],
    }
  },
  created() {

  },
  methods: {
    handleShow(id) {
      goodsOrderApi.getLogisticsNumber({ logisticsNumber: id }).then(({ data }) => {
        let logistics = data ? JSON.parse(data) : {};
        let { list } = logistics && logistics.result;
        this.list = list || []
        if (this.list.length > 0) this.formVisible = true
        else this.$message.error(logistics.msg)  
        
      })
    },
  }
}
</script>
<style lang="scss" scoped>
</style>